module.exports = __webpack_public_path__ + "assets/img/5.bae7f6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/why/5.jpg
// module id = vXsC
// module chunks = 1